import apiClient from './client';

export interface SalesReportPayload {
  reportInfo: {
    restaurantName: string;
    reportTitle: string;
    generatedAt: string;
    periodStart: string;
    periodEnd: string;
    firstInvoiceDate: string | null;
    lastInvoiceDate: string | null;
    accountantName: string;
  };
  salesSummary: {
    totalOrders: number;
    grossSales: number;
    netSales: number;
    averageOrderValue: number;
  };
  orderSummary: Array<{
    type: string;
    count: number;
    total: number;
    percentage: number;
  }>;
  transactions: Array<{
    id: string;
    invoiceNumber: string;
    createdAt: string;
    customerName: string;
    orderType: string;
    status: string;
    totalAmount: number;
    cashierName: string;
  }>;
  returnsAndRefunds: {
    count: number;
    totalValue: number;
  };
  operationalStats: {
    highestInvoiceAmount: number;
    lowestInvoiceAmount: number;
    averageInvoiceAmount: number;
    totalItemsSold: number;
    bestSellingProducts: Array<{ name: string; quantity: number }>;
    peakSalesHour: string;
    cancelledOrdersCount: number;
  };
}

export const salesReportApi = {
  getSalesReport: async (startDate: string, endDate: string): Promise<{ success: boolean; data: SalesReportPayload }> => {
    const response = await apiClient.get('/reports/sales', {
      params: { startDate, endDate },
    });
    return response.data;
  },
};
